"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _useViewerContext2 = require("../hooks/use-viewer-context");

var _openSeadragon = require("../open-seadragon");

var Overlay = function Overlay(_ref) {
  var x = _ref.x,
      y = _ref.y,
      height = _ref.height,
      width = _ref.width,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["x", "y", "height", "width", "children"]);

  var _useViewerContext = (0, _useViewerContext2.useViewerContext)(),
      viewer = _useViewerContext.viewer,
      isReady = _useViewerContext.isReady;

  var rootElemRef = (0, _react.useRef)(document.createElement('div'));
  (0, _react.useEffect)(function () {
    if (isReady) {
      viewer.addOverlay((0, _objectSpread2["default"])({
        element: rootElemRef.current,
        location: !height || !width ? new _openSeadragon.OpenSeadragon.Point(x, y) : new _openSeadragon.OpenSeadragon.Rect(x, y, width, height)
      }, props));
      var rootEl = rootElemRef.current;
      return function () {
        if (viewer) {
          viewer.removeOverlay(rootEl);
        }
      };
    }

    return; // eslint-disable-next-line
  }, [viewer, isReady]);
  (0, _react.useEffect)(function () {
    if (isReady) {
      var overlay = viewer.getOverlayById(rootElemRef.current);
      overlay.update(!height || !width ? new _openSeadragon.OpenSeadragon.Point(x, y) : new _openSeadragon.OpenSeadragon.Rect(x, y, width, height));
    }
  }, [height, viewer, width, x, y]);
  return _reactDom["default"].createPortal(children, rootElemRef.current);
};

exports.Overlay = Overlay;